module.exports = __webpack_public_path__ + "img/deep-learning-indaba.b531f66f.png";